import { render, staticRenderFns } from "./ProductSummaryControls.vue?vue&type=template&id=3c1ac33d&scoped=true"
import script from "./ProductSummaryControls.vue?vue&type=script&lang=js"
export * from "./ProductSummaryControls.vue?vue&type=script&lang=js"
import style0 from "./ProductSummaryControls.vue?vue&type=style&index=0&id=3c1ac33d&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c1ac33d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/bitrix/ext_www/igr.ru/local/templates/main/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3c1ac33d')) {
      api.createRecord('3c1ac33d', component.options)
    } else {
      api.reload('3c1ac33d', component.options)
    }
    module.hot.accept("./ProductSummaryControls.vue?vue&type=template&id=3c1ac33d&scoped=true", function () {
      api.rerender('3c1ac33d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ProductSummaryControls.vue"
export default component.exports